/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module sizeSelectionModal
 */

import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';

export const PLUGIN_NAME = 'sizeSelectionModal';
export const DEFAULTS = {
    sessionName: '',
    loadAfterCallback: function () { }
};
/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
const mergeOptions = ($el, options = {}) => {
    const opts = Object.assign({}, DEFAULTS, $el.data(), options);
    return opts;
  };

const showConfirmation = (opts, hasError, $el) => {
    const {saveSizeConfirmPath} = opts;
    $.modal({
        url: `${saveSizeConfirmPath}`,
        triggerOpen: true,
        type: 'notification',
        returnFocus: $el,
    })
}

const updateSizeToDb = ($el, opts, sizeValue) => {
    if (sizeValue) {
        // const {updateSizePath, code} = opts;
        showConfirmation(opts, false, $el);
        // $.ajax({
        //     url: `${updateSizePath}${sizeValue}`,
        //     type: "POST",
        //     success: function (success) {
        //         if (success) {
        //             showConfirmation(opts, false, $el);
        //             if(typeof logEngagementWithDetails === "function") {
        //                 logEngagementWithDetails(window.location.href, 'favorites save your size', 'SaveSize', `size=${sizeValue}, code=${code}`);
        //             }
        //         }
        //     }
        // });
    } else {
        showConfirmation(opts, true, $el);
    }
}

const setUpdateSizeListener = ($el, opts) => {
    $('#select-size-form').on('submit', function(evt) {
        evt.preventDefault();
        const $selectedInput =  $('input[name="fav-size-selection"]:checked');
        if(!$selectedInput.length) {
            const $selectSizeForm = $(this);
            const $formField = $selectSizeForm.find('.field');
            const $formLegend = $selectSizeForm.find('legend');
            $formField.addClass('is-error');
            $formLegend.attr('aria-labelledby', 'select-size-error').trigger('focus');
            $('input[name="fav-size-selection"]').on('change',function(){
                $formField.removeClass('is-error');
                $formLegend.removeAttr('aria-labelledby');
            });
            return;
        }
        const sizeSelected = $selectedInput.val();
        const {code, addToBag} = opts;
        // $el.html(`<span id="${code}-fav-size-value" data-size="${sizeSelected}">Size: ${sizeSelected}</span>`); // update size copy
        updateSizeToDb($el, opts, sizeSelected);
        if (addToBag === 'true') {
            const $addToBag = $(`#add-to-bag-${code}`);
            if ($addToBag.length) {
                $addToBag.click();
            }
        }
    })
}


const getSizes = ($el, opts) => {
    const {sizePath} = opts;
    opts.addToBag = $el.data('addToBag');
    $el.data('addToBag', 'false');
    $.modal({
        url: sizePath,
        triggerOpen: true,
        type: "small",
        addModifierClass: 'modal--toast-sizes',
        returnFocus: $el,
        onComplete: function() {
            setUpdateSizeListener($el, opts);
        }
    })
}

/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, opts) => {
    $el.on('click', (evt) => {
        evt.preventDefault();
        getSizes($el, opts);
    });
};


/**
 * Initializes sizeSelectionModal.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelectionModal
 * @see DEFAULTS
 */
export default function sizeSelectionModal(el, options = {}) {
    const $el = $(el);
    const opts = mergeOptions($el, options);
    setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, sizeSelectionModal);



// WEBPACK FOOTER //
// ./src/scripts/entry-points/shoppingbag/size-selection-modal.js